//トップメニューのリンクをホバーしたときに、子リンクが定義されていれば、そのリンク集をポップアップする
const globalPopup = document.getElementById('global-popup');
const popupContents = document.querySelectorAll('.popup-content');

//NOTE: 非同期処理による race condition が原因で、setTimeoutの非表示予定が残った状態で、別リンクをホバーするとpopupが非表示になってしまうため
let hideTimer = null;

document.querySelectorAll('.hover-link').forEach(link => {
    const targetId = link.dataset.target;
    const popup = document.getElementById(targetId);

    // 表示処理
    link.addEventListener('mouseenter', () => {
        // 非表示タイマーをキャンセル
        if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
        }

        // すべて非表示に
        popupContents.forEach(p => p.classList.add('d-none'));

        // 対象だけ表示
        popup.classList.remove('d-none');
        globalPopup.classList.remove('d-none');

        // 中央位置の計算
        const linkRect = link.getBoundingClientRect();
        const popupRect = globalPopup.getBoundingClientRect();

        const linkCenter = linkRect.left + linkRect.width / 2;
        const leftOffset = linkCenter - popupRect.left;

        // 矢印位置を設定（::before の left）
        globalPopup.style.setProperty('--arrow-left', `${leftOffset}px`);
    });

    // 非表示処理（少し遅延を入れて 親リンクから popup へ移動するまでの猶予を作る）
    link.addEventListener('mouseleave', () => {
        hideTimer = setTimeout(() => {
            if (!globalPopup.matches(':hover')) {
                globalPopup.classList.add('d-none');
            }
            hideTimer = null;
        }, 200);
    });

    // popup 上にマウスがあるときは表示する
    globalPopup.addEventListener('mouseenter', () => {
        if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
        }
        globalPopup.classList.remove('d-none');
    });

    // popup からマウスが離れたら非表示
    globalPopup.addEventListener('mouseleave', () => {
        globalPopup.classList.add('d-none');
    });
});
